// extracted by mini-css-extract-plugin
export default {"SplitPane":"SplitPane_yZDvj","ResizerHorizontal":"ResizerHorizontal_e9mSk","Resizer":"Resizer_CItLP"};